import styled from "styled-components";


 export const TakeImageWrapper = styled.div`
 background-color: #fff;
 padding: 10px;
 box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
 max-width: 300px;
 border-radius: 10px;
 video{
    width: 100%;
    border-radius: 10px;
 }
 `;